import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AdditionalDataFormItem.module.scss';
import { Col } from 'react-flexbox-grid';
import FormItem from 'common/components/formItem/FormItem';
import Label from 'common/components/label/Label';
import InputError from 'common/components/inputError/InputError';
import { Controller, UseFormMethods } from 'react-hook-form';
import InputController from 'common/components/input/InputController';
import DateTimePickerControllerNew from 'common/components/dateTimePicker/DateTimePickerControllerNew';

type Props = {
    form: UseFormMethods<any>;
    isDetails?: boolean
    index: number;
    className?: string;
    xl?: number;
    lg?: number;
    md?: number;
    sm?: number;
    xs?: number;    
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const AdditionalDataFormItem: React.FC<Props> = ({
    form,
    isDetails,
    index,
    className,
    xl,
    lg,
    md,
    sm,
    xs
}: Props) => {
    const { t } = useTranslation();
    const errors = (form.errors?.additionalData || [])[index] || null;
    const [designation, setDesignation] = useState<string | undefined>();
    const [type, setType] = useState<string>('TEXT');
    const [loaded, setLoaded] = useState<boolean>(false);

    useEffect(() => {
        setDesignation(form.getValues(`additionalData[${index}].designation`));
        setType(form.getValues(`additionalData[${index}].type`))
        setLoaded(true);
    }, []);

    return (
        <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl} className={`${className || ''}`} key={`form_additional_items_input`}>
            <FormItem>
                <Label className={styles.label}>{designation}</Label>
                {(type === 'TEXT' || type === 'NUMBER') &&
                    <InputController
                        name={`additionalData[${index}].value`}
                        form={form as any}
                        autoComplete='off'
                        placeholder={designation}
                        type={type.toLowerCase() || 'text'}
                        disabled={isDetails}
                        format={type.toLocaleLowerCase() === 'number' ? 'number' : undefined} 
                        numberDecimalCases={type.toLocaleLowerCase() === 'number' ? 6 : undefined}
                        noFixedDecimalCase={type.toLocaleLowerCase() === 'number' ? true : undefined}
                    />
                }
                {(type === 'DATE' && loaded) &&
                    <DateTimePickerControllerNew
                        form={form}
                        placeholderText={designation}
                        name={`additionalData[${index}].value`}
                        autoComplete='off'
                        disabled={isDetails} />

                }
                {(type === 'BOOLEAN') &&
                    <Controller
                        render={({ onChange, value, ref }) => {
                            return (
                                <label
                                    ref={ref}
                                    className={`${styles.toggleSwitch} ${isDetails ? styles.disabled : styles.enabled}`}>
                                    <input
                                        type='checkbox'
                                        checked={`${value}`.toLowerCase() === 'true'}
                                        ref={ref}
                                        onChange={e => {
                                            if (!isDetails) {
                                                onChange(e.target.checked ? 'true' : 'false');
                                            }
                                        }}
                                    />
                                    <span className={styles.switch} />
                                </label>
                            );
                        }}
                        key={`additionalData[${index}].value`}
                        control={form.control}
                        name={`additionalData[${index}].value`}
                        defaultValue={form.getValues(`additionalData[${index}].value`) || null}
                    />
                }
                <InputError error={errors?.value} />
            </FormItem>
        </Col>
    );
}

export default AdditionalDataFormItem;
